import { render } from "./OpenScanner.vue?vue&type=template&id=21d9a33a&scoped=true"
import script from "./OpenScanner.vue?vue&type=script&lang=js"
export * from "./OpenScanner.vue?vue&type=script&lang=js"

import "./OpenScanner.vue?vue&type=style&index=0&id=21d9a33a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\utente\\Documents\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d9a33a"]])

export default __exports__